import { useEffect, useMemo, useRef, useState } from "react";
import { getActiveExecutionSubGroup } from "../services/executionSubGroup";
import {
  buildExecutionSubGroupMap,
  ExecutionSubGroupMap,
} from "../utils/executionGroup";

/**
 * Provides an `id -> { name, code }` lookup for Execution Sub Groups.
 *
 * DQ-8684: result rows carry only `execution_sub_group_id` / `_code`, so the
 * display name is resolved client-side against the `/execution-sub-group` list
 * that the sub group dropdown already uses. Fetched once per mount and
 * memoized; callers fall back to the row's code or id while it loads.
 */
const useExecutionSubGroupMap = (): ExecutionSubGroupMap => {
  const [options, setOptions] = useState<any[]>([]);
  const hasFetchedRef = useRef<boolean>(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    let isActive = true;
    (async () => {
      try {
        const result = await getActiveExecutionSubGroup();
        if (isActive) setOptions(result || []);
      } catch (err) {
        console.error("Error fetching execution sub groups:", err);
      }
    })();

    return () => {
      isActive = false;
    };
  }, []);

  return useMemo(() => buildExecutionSubGroupMap(options), [options]);
};

export default useExecutionSubGroupMap;
